App = App || {};

App.ManagePromotions = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("manage-promotions");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = true;

		new Vue({
			el: rootElement,
			data: {
				fieldDefs: [
					{ key: "isEnabled", label: "", sortable: false, class: "pl-3" },
					{ key: "name", label: "Name", sortable: true },
					{ key: "type", label: "Type", sortable: true },
					{ key: "factor", label: "Factor", sortable: true },
					{ key: "startDate", label: "Starts", sortable: true },
					{ key: "endDate", label: "Ends", sortable: true },
				],
				isLoading: false,
				page: 1,
				pageSize: 10,
				sortBy: "name",
				sortDesc: false,
				totalItems: 0,
				firstItem: 0,
				lastItem: 0
			},
			computed: {
				fieldsWithColumnSelect: function () {
					var viewModel = this;
					return viewModel.fieldDefs.map((field) => {
						var sortedClass = viewModel.sortBy === field.key ? "is-sorted" : "";
						return Object.assign({}, field, { thClass: sortedClass, tdClass: sortedClass });
					});
				},
				totalPages: function () {
					return Math.max(1, Math.ceil((this.totalItems || 0) / (this.pageSize || 1)));
				}
			},
			methods: {
				provider: function (context) {
					var requestParameters = {
						page: context.currentPage,
						pageSize: context.perPage,
						sortBy: context.sortBy || this.sortBy || "",
						sortDir: (context.sortDesc === true) ? "desc" : "asc"
					};

					return $.ajax({
						url: "/api/promotions/paged",
						method: "GET",
						dataType: "json",
						data: requestParameters,
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							context.currentPage = response.data.page;
							context.perPage = response.data.pageSize;
							this.totalItems = response.data.total;
							this.firstItem = response.data.firstItem;
							this.lastItem = response.data.lastItem;
							return response.data.items;
						}

						context.totalItems = 0;
						return [];

					}).catch((error) => {
						console.error("BalanceHistory provider error:", error);
						context.totalItems = 0;
						return [];
					});
				},

				refresh: function () {
					this.page = 1;
					this.$refs.table.refresh();
				},

				redraw: function () {
					this.$refs.table.refresh();
				},

				formatDate: function (value) {
					if (!value)
						return "";

					const normalizedIsoString = String(value).replace(/(\.\d{3})\d+$/, "$1");
					const date = new Date(normalizedIsoString);

					if (isNaN(date))
						return String(value);

					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				onRowClicked: function (item, index, evt) {
					if (!item || !item.id)
						return;

					if (window.App && App.PromotionDetail && App.PromotionDetail.open) {
						App.PromotionDetail.open(item.id, () => this.redraw());
					}
				},

				addPromotion: function () {
					if (window.App && App.PromotionDetail && App.PromotionDetail.create) {
						App.PromotionDetail.create(() => this.redraw());
					}
				}
			},
			mounted: function () {
				this.$nextTick(() => {
					this.$refs.table.refresh();
				});
			}
		});
	}

	return { init: init };
})(jQuery, Vue);

App.ManagePromotions.init();
